<template>
  <div v-if="isDebugMode">
    <button
      @click="updateShowDebugUI(!showDebugUI)"
      class="btn btn-sm btn-warning"
      type="button"
      aria-label="Toggle debug UI"
    >
      <i v-if="showDebugUI" class="bi bi-eye-slash"></i>
      <i v-else class="bi bi-eye"></i>
      {{ showDebugUI ? "Hide Debug UI" : "Show Debug UI" }}
    </button>
  </div>
</template>

<script>
export default {
  name: "DebugInterface",
  props: {
    showDebugUI: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isDebugMode() {
      return import.meta.env.VITE_DEBUG === "true";
    }
  },
  emits: ["update:showDebugUI"],
  methods: {
    updateShowDebugUI(value) {
      this.$emit("update:showDebugUI", value);
    }
  }
};
</script>

<style scoped></style>
